import styled from "styled-components";

import { MovieDetailStyledProps as Props } from "./MovieDetail.types";
import CONSTANTS from "config/constants";

const { tablet, desktop } = CONSTANTS.BREAKPOINTS;

const MovieDetailStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;
  padding-top: var(--sizes-navbar-height);

  @media (max-width: ${tablet}px) {
    padding-top: var(--sizes-navbar-height-mobile-without-search);
  }

  .MovieDetail {
    &__header {
      grid-column: fullBleed;
    }

    &__go-back-desktop {
      display: flex;
      height: auto;
      justify-content: start;
      margin-bottom: 1.6rem;

      .GoBack {
        margin-bottom: 2.4rem;

        &__icon {
          padding-left: 0.8rem;

          path {
            fill: var(--palette-white);
          }
        }

        &__title {
          font-weight: 600;
          font-size: 1.6rem;
          color: var(--palette-white);

          @media (max-width: ${tablet}px) {
            font-size: 1.4rem;
          }
        }
      }
    }

    &__buttons {
      display: flex;
      padding-left: 1.6rem;
      padding-top: 2.4rem;

      &__trailer {
        margin-top: 1.6rem;
        font-weight: 700;
        font-size: 1.6rem;

        & > a {
          color: var(--palette-primary);
          text-decoration: none;
          display: flex;
          align-items: center;

          & > svg {
            margin-right: 0.8rem;

            path {
              fill: var(--palette-primary);
            }
          }
        }

        &:hover:not([disabled]) {
          background-color: transparent;
          color: var(--palette-primary);
        }

        @media (max-width: ${tablet - 1}px) {
          font-size: 1.4rem;
        }
      }
    }

    &__main {
      grid-column: content;
      display: flex;
      flex-direction: column;
      padding: 8rem 0;
      z-index: 1;

      @media (max-width: ${tablet}px) {
        z-index: 0;
      }

      &__header {
        padding-bottom: 4rem;

        @media (max-width: ${tablet}px) {
          margin-top: -4rem;
          padding-bottom: 0;
        }
      }
    }

    &__background {
      position: absolute;
      width: 100%;
      top: 0;
      min-height: 64rem;
      background-image: url(${props => props.image});
      background-size: cover;
      background-position-y: center;

      @media (max-width: ${desktop}px) {
        min-height: 48rem;
      }

      &::after {
        content: "";
        background-image: linear-gradient(
          180deg,
          transparent,
          var(--palette-black-s15-l8)
        );
        min-height: 64.8rem;
        position: absolute;
        top: 0;
        width: 100%;
        backdrop-filter: blur(0.8rem);

        @media (max-width: ${desktop}px) {
          min-height: 48rem;
        }
      }
    }

    &__tabs {
      display: none;

      @media (max-width: ${tablet}px) {
        display: flex;
      }

      .ScrollableTabs {
        &__item {
          &__label {
            color: var(--palette-light-blue-s10-l60);

            &__container {
              display: flex;
              flex-direction: column;
            }

            &-active {
              color: var(--palette-white);
            }
          }

          &__marker {
            height: 0.1rem;
            width: 4.8rem;
          }
        }
      }
    }

    &__wrapper__title {
      font-size: 2.4rem;
      color: var(--palette-gray-s0-l70);

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__information {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__content {
      grid-template-columns: auto auto;
      gap: 16rem;
      display: grid;

      @media (max-width: ${desktop}px) {
        gap: 8rem;
      }

      @media (max-width: ${tablet}px) {
        grid-template-columns: auto;
        gap: 2.4rem;
      }

      .MovieCard {
        width: fit-content;

        &__icon-image {
          width: max-content;
          height: max-content;
        }

        &__title {
          margin-top: 0.8rem;
        }

        &__duration {
          padding-bottom: 3.2rem;
        }

        &__text {
          font-size: 1.4rem;
        }
      }

      &__trailer {
        @media (max-width: ${tablet}px) {
          display: none;
        }
      }

      &__card {
        max-width: fit-content;
      }

      &__days {
        padding-bottom: 2rem;
      }

      &__sessions {
        font-size: 2rem;
        font-weight: 600;
        color: var(--palette-gray-s0-l70);
        padding-bottom: 2.4rem;
      }

      &__session-type {
        padding: 2.4rem;
        border-radius: 2.4rem;
        background-color: ${props =>
          props.notFunctions ? "unset" : "var(--palette-mid-blue-s13-l18) "};

        &-text {
          font-size: 2.4rem;
          color: var(--palette-gray-s0-l70);
          padding-bottom: 2.4rem;
          font-weight: 600;
        }

        @media (max-width: ${tablet}px) {
          padding: 0.8rem;
        }
      }

      &__session {
        padding-bottom: 4rem;
        width: min-content;

        @media (max-width: ${desktop}px) {
          width: auto;
          min-width: 100%;
        }
      }
    }

    &__status-wrapper {
      display: flex;
      justify-content: center;
      padding-bottom: 2rem;
      align-items: center;

      @media (max-width: ${tablet}px) {
        justify-content: start;
        margin-top: 1.6rem;
      }
    }

    &__footer {
      grid-column: fullBleed;
    }
  }
`;

export default MovieDetailStyled;
